var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82766 9.22391C4.93748 9.22455 5.04636 9.20356 5.14803 9.16215C5.2497 9.12075 5.34218 9.05974 5.42015 8.98263C5.49837 8.90528 5.56045 8.81326 5.60281 8.71187C5.64518 8.61048 5.66699 8.50173 5.66699 8.3919C5.66699 8.28206 5.64518 8.17331 5.60281 8.07192C5.56045 7.97053 5.49837 7.87851 5.42015 7.80116L2.65798 4.99924L5.42433 2.19727C5.57975 2.04138 5.66699 1.8305 5.66699 1.6107C5.66699 1.39089 5.57975 1.18001 5.42433 1.02412C5.34675 0.946141 5.25446 0.884243 5.15276 0.842003C5.05107 0.799762 4.942 0.778015 4.83184 0.778015C4.72167 0.778015 4.6126 0.799762 4.51091 0.842003C4.40922 0.884243 4.31692 0.946141 4.23935 1.02412L0.905538 4.41683C0.752637 4.57236 0.666992 4.78146 0.666992 4.99924C0.666992 5.21702 0.752637 5.42613 0.905538 5.58165L4.24351 8.95767C4.31842 9.03832 4.4086 9.10337 4.50887 9.14907C4.60913 9.19477 4.71748 9.2202 4.82766 9.22391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.17ac75a0312507c3a836b666778a20c2.svg";
export { ForwardRef as ReactComponent };